var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "horizontal-item" }, [
        _c("div", [
          _c("div", [
            _c(
              "div",
              { staticClass: "position-relative pt-3 px-3" },
              [
                _c("small-carousel", {
                  attrs: {
                    images: _vm.images,
                    "show-indicators": false,
                    height: "200px"
                  }
                }),
                _vm._v(" "),
                true || _vm.isOffertaSpeciale
                  ? _c("div", { staticClass: "circle-area" }, [
                      _c("p", [_vm._v("Offerta Speciale")])
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "px-3 pb-3" }, [
              _c("div", { staticClass: "pb-2" }, [
                _c(
                  "div",
                  {
                    staticClass: "type-info",
                    class: _vm.isHighlight ? "bg-primary" : ""
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.label))])]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex" }, [
                  _c("div", { staticClass: "date-info" }, [
                    _c("h3", { staticClass: "m-0 cursive" }, [
                      _vm._v(_vm._s(_vm.day))
                    ]),
                    _vm._v(" "),
                    _c("h5", { staticClass: "text-uppercase m-0" }, [
                      _vm._v(_vm._s(_vm.month))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item-info" }, [
                    _c("h5", { staticClass: "cursive" }, [
                      _vm._v(_vm._s(_vm.name))
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("div", { staticClass: "detail-info" }, [
                  _c("div", [
                    _c("span", { staticClass: "notti nowrap" }, [
                      _c("b", [_vm._v(_vm._s(this.nights))]),
                      _vm._v(" notti - "),
                      _c("b", [_vm._v(_vm._s(this.days))]),
                      _vm._v(" giorni\n                                ")
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.isPartenzaGarantita
                    ? _c("div", [
                        _vm.isPartenzaGarantita
                          ? _c("span", { staticClass: "partenza-garantita" }, [
                              _vm._v("partenza garantita")
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "dates-info" }, [
                  _vm.isAltreDate
                    ? _c("div", { staticClass: "position-relative" }, [
                        _c(
                          "a",
                          {
                            staticClass: "dates text-primary",
                            attrs: { href: "javascript:void(0)" },
                            on: {
                              click: function($event) {
                                _vm.showAltreDate = !_vm.showAltreDate
                              }
                            }
                          },
                          [_vm._v("altre date disponibili")]
                        ),
                        _vm._v(" "),
                        _vm.showAltreDate
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "position-absolute p-1 border rounded bg-white",
                                staticStyle: {
                                  "z-index": "10",
                                  "max-height": "130px",
                                  overflow: "auto"
                                },
                                on: {
                                  mouseleave: function($event) {
                                    _vm.showAltreDate = false
                                  },
                                  click: function($event) {
                                    _vm.showAltreDate = false
                                  }
                                }
                              },
                              _vm._l(_vm.departureFutureDates, function(
                                item,
                                index
                              ) {
                                return _c(
                                  "button",
                                  {
                                    key: index,
                                    staticClass:
                                      "rounded-0 mb-1 mx-1 px-1 btn btn-outline-primary btn-sm",
                                    staticStyle: { width: "42px" },
                                    on: {
                                      click: function($event) {
                                        return _vm.onOpenDetailWithDate(item)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.formatDate(item)))]
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex justify-content-between pt-3 px-3" },
            [
              _c("div", [
                _c("h6", { staticClass: "text-uppercase mb-0" }, [
                  _vm._v("a partire da")
                ]),
                _vm._v(" "),
                _c("h1", { staticClass: "currency" }, [
                  _vm._v(_vm._s(_vm.price) + " €")
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-lg px-5",
                    on: { click: _vm.onOpenDetail }
                  },
                  [_vm._v("scegli")]
                )
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("ModalTourDetail", {
        ref: "modalTourDetail",
        attrs: {
          value: _vm.value,
          "is-home-page": true,
          "is-camere-requested": _vm.isHomePage
        },
        on: { select: _vm.onSelect }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66bc6e24", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66bc6e24","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/mobile/widgets/common/tours/HorizontalItemTour.vue
// module id = null
// module chunks = 